/* Native forms remain usable if JavaScript is unavailable. */
(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-menu]').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      const summary = menu.querySelector('summary');
      const sync = () => { if (menu.open) menu.style.setProperty('--menu-top', `${menu.closest('.site-header').getBoundingClientRect().bottom}px`); document.body.classList.toggle('menu-open', menu.open); summary.setAttribute('aria-expanded', String(menu.open)); };
      summary.setAttribute('aria-expanded', String(menu.open));
      menu.addEventListener('toggle', sync);
      menu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => { menu.open = false; sync(); }));
      menu.addEventListener('keydown', e => { if (e.key === 'Escape') { menu.open = false; sync(); summary.focus(); } });
      menu.addEventListener('keydown', e => {
        if (e.key !== 'Tab' || !menu.open) return;
        const items = [...menu.querySelectorAll('summary, a[href]')];
        if (e.shiftKey && document.activeElement === items[0]) { e.preventDefault(); items.at(-1).focus(); }
        else if (!e.shiftKey && document.activeElement === items.at(-1)) { e.preventDefault(); items[0].focus(); }
      });
      window.matchMedia('(min-width: 801px)').addEventListener('change', e => { if (e.matches) { menu.open = false; sync(); } });
    });
    root.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const form = section.querySelector('[data-product-form]');
      const select = section.querySelector('[data-variant-select]');
      const qty = form?.querySelector('[name="quantity"]');
      const addButton = section.querySelector('[data-add-button]');
      const addLabel = section.querySelector('[data-add-label]');
      const message = section.querySelector('[data-product-message]');
      const mainImage = section.querySelector('[data-main-image]');
      const imageLink = section.querySelector('[data-main-image-link]');
      const setImage = (src, alt) => {
        if (!src || !mainImage) return;
        mainImage.removeAttribute('srcset'); mainImage.src = src; mainImage.alt = alt || '';
        if (imageLink) imageLink.href = src;
        section.dispatchEvent(new CustomEvent('beldi:image-change', {detail:{src,alt}}));
      };
      section.querySelectorAll('[data-thumbnail]').forEach(thumb => {
        thumb.addEventListener('click', e => {
          e.preventDefault(); setImage(thumb.dataset.full, thumb.dataset.alt);
          section.querySelectorAll('[data-thumbnail]').forEach(el => el.removeAttribute('aria-current'));
          thumb.setAttribute('aria-current', 'true');
        });
      });
      select?.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const available = option.dataset.available === 'true';
        section.querySelector('[data-product-price]').textContent = option.dataset.price;
        const compare = section.querySelector('[data-compare-price]');
        compare.textContent = option.dataset.compare || ''; compare.hidden = !option.dataset.compare;
        addButton.disabled = !available;
        addLabel.textContent = available ? 'Ajouter au panier' : 'Produit épuisé';
        section.querySelector('[data-stock-status]').textContent = available ? 'Disponible' : 'Épuisé';
        if (qty) { qty.min = option.dataset.min || '1'; qty.step = option.dataset.step || '1'; if (option.dataset.max) qty.max = option.dataset.max; else qty.removeAttribute('max'); qty.value = qty.min; }
        setImage(option.dataset.image, option.dataset.imageAlt);
        if (option.dataset.image) section.querySelectorAll('[data-thumbnail]').forEach(el => el.removeAttribute('aria-current'));
        const url = new URL(window.location.href); url.searchParams.set('variant', select.value); window.history.replaceState({}, '', url);
        if (message) message.textContent = '';
      });
      section.querySelectorAll('[data-quantity]').forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => { if (button.dataset.quantity === 'plus') qty.stepUp(); else qty.stepDown(); qty.dispatchEvent(new Event('change', { bubbles: true })); });
      });
      form?.addEventListener('submit', async e => {
        if (!window.fetch || !form.checkValidity()) return;
        e.preventDefault();
        if (addButton.disabled) return;
        addButton.disabled = true; addButton.setAttribute('aria-busy', 'true'); addLabel.textContent = 'Ajout en cours…'; message.textContent = '';
        const rootUrl = window.Shopify?.routes?.root || '/';
        try {
          const response = await fetch(`${rootUrl}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || 'Ce soin n’a pas pu être ajouté. Vérifiez votre sélection.');
          message.textContent = 'Votre soin a été ajouté. ';
          const link = document.createElement('a'); link.href = `${rootUrl}cart`; link.textContent = 'Voir mon panier →'; message.append(link);
          try {
            const cartResponse = await fetch(`${rootUrl}cart.js`, { headers: { Accept: 'application/json' } });
            if (cartResponse.ok) { const cart = await cartResponse.json(); document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; }); }
          } catch { /* The add succeeded; a count refresh failure does not undo it. */ }
        } catch (error) {
          message.textContent = error.message === 'Failed to fetch' ? 'La connexion a été interrompue. Consultez votre panier avant de réessayer.' : error.message;
          message.focus();
        } finally {
          addButton.disabled = select ? select.selectedOptions[0].dataset.available !== 'true' : false;
          addButton.removeAttribute('aria-busy'); addLabel.textContent = addButton.disabled ? 'Produit épuisé' : 'Ajouter au panier';
        }
      });
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', () => document.body.classList.remove('menu-open'));
})();

// Manual testimonials use only the four received messages; product reviews remain app-managed.
(()=>{const init=(root=document)=>{root.querySelectorAll('[data-customer-reviews]').forEach(section=>{if(section.dataset.reviewsReady)return;section.dataset.reviewsReady='true';const grid=section.querySelector('.reviews-grid'),select=section.querySelector('[data-review-sort]');if(!grid||!select)return;const cards=[...grid.querySelectorAll('[data-review-card]')];section.querySelector('[data-review-sort-control]').hidden=false;select.addEventListener('change',()=>{const ordered=[...cards];if(select.value==='detailed')ordered.sort((a,b)=>b.querySelector('blockquote').textContent.length-a.querySelector('blockquote').textContent.length);grid.append(...ordered);});});};init();document.addEventListener('shopify:section:load',event=>init(event.target));})();
